"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObjectArea = void 0;
var React = _interopRequireWildcard(require("react"));
var _Anchor = require("../Anchor");
var _Polygon = require("../Polygon");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ObjectArea = _ref => {
  let {
    isActive,
    polygonPath,
    polygonRef,
    anchorRef,
    onClick,
    center
  } = _ref;
  const [hovered, setHovered] = React.useState(false);
  const handleMouseEnter = React.useCallback(() => setHovered(true), []);
  const handleMouseLeave = React.useCallback(() => setHovered(false), []);
  const isFocused = hovered || isActive;
  return /*#__PURE__*/React.createElement("div", {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(_Polygon.Polygon, {
    path: polygonPath,
    isActive: isFocused,
    ref: polygonRef
  }), /*#__PURE__*/React.createElement(_Anchor.Anchor, {
    isActive: isFocused,
    ref: anchorRef,
    center: center
  }));
};
exports.ObjectArea = ObjectArea;